import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Sarah Mitchell",
    designation: "Home User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "I purchased an inkjet printer from here and the setup was super easy. Print quality is excellent and delivery was surprisingly fast. I will definitely be returning for ink refills.",
  },
  {
    name: "Michael Carter",
    designation: "Small Business Owner",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Finding a reliable laser printer for my office used to be a headache. This store made it easy with great product comparisons and honest details. The support team helped me pick the perfect model.",
  },
  {
    name: "Jessica Lopez",
    designation: "Frequent Printer User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Great pricing and a wide range of printers. I love how smooth the ordering experience was. The product arrived well packed and worked perfectly right out of the box.",
  },
  {
    name: "Daniel Roberts",
    designation: "IT Professional",
    image: "/assets/img/icon/user-avatar.svg",
    text: "As someone who handles tech for multiple offices, I appreciate the clarity in specifications and compatibility. Excellent customer support and fast shipping make this my go to source.",
  },
  {
    name: "Emma Williams",
    designation: "Teacher",
    image: "/assets/img/icon/user-avatar.svg",
    text: "The printer I bought is perfect for my classroom. It’s fast, quiet and prints worksheets perfectly every time. The pricing and customer care were outstanding.",
  },
  {
    name: "James Parker",
    designation: "Home Office User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "I had questions before ordering and the support team gave clear helpful guidance. My printer works perfectly and I love the automatic wireless printing feature.",
  },
];

function TestimonialOne() {
  return (
    <section
      className="testi-area overflow-hidden space shape-mockup-wrap"
      id="testi-sec"
    >
      <div className="container-fluid p-0">
        <div className="title-area mb-20 text-center">
          <span className="sub-title">Testimonial</span>
          <h2 className="sec-title">What Clients Say About Us</h2>
        </div>
        <div className="slider-area">
          <Swiper
            modules={[Pagination, Navigation]}
            pagination={{ clickable: true }}
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            slidesPerGroup={1}
            speed={1200}
            breakpoints={{
              0: { slidesPerView: 1 },
              767: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: 2 },
              1400: { slidesPerView: 3 },
            }}
            className="testiSlider1 has-shadow"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testi-card">
                  <div className="testi-card_wrapper">
                    <div className="testi-card_profile">
                      <div className="testi-card_avater">
                        <img src={item.image} alt="testimonial" />
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{item.name}</h3>
                        <span className="testi-card_desig">
                          {item.designation}
                        </span>
                      </div>
                    </div>
                    <div className="testi-card_review">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fa-solid fa-star" />
                      ))}
                    </div>
                  </div>
                  <p className="testi-card_text">{item.text}</p>
                  <div className="testi-card-quote">
                    <img src="/assets/img/icon/testi-quote.svg" alt="img" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="slider-pagination" />
        </div>
      </div>
      <div
        className="shape-mockup d-none d-xl-block"
        style={{ bottom: "-2%", right: "0%" }}
      >
        <img src="/assets/img/shape/line2.png" alt="shape" />
      </div>
      <div
        className="shape-mockup movingX d-none d-xl-block"
        style={{ top: "30%", left: "5%" }}
      >
        <img src="/assets/img/shape/shape_7.png" alt="shape" />
      </div>
    </section>
  );
}

export default TestimonialOne;
